module.exports = __webpack_public_path__ + "img/eos_gmbh_logo.61e85101.svg";